import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { AttachmentsMacroRendererProps } from '../src/AttachmentsMacroRenderer.tsx';

export const AttachmentsMacroHandler: LoadableType<AttachmentsMacroRendererProps> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AttachmentsMacro" */ '../src/AttachmentsMacroRenderer.tsx'
			)
		).AttachmentsMacroRenderer,
});
